import React, {useContext, useState} from "react";
import ContactInfoForm from './ContactInformationForm'
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import { Button,Modal} from 'react-bootstrap';
import './ClientPortal.css'
import { For } from '../CommonComponents/Routes';

export default () => {
    let RecordsController = useContext(RecordsManagementContext);
    const isStorage = For === 'storage';

    // Branch data sources by mode (use const, assign via conditional objects)
    const sp = isStorage ? (RecordsController.SP_PageDetails || {}) : null;
    const cpDetails = !isStorage ? (RecordsController.CP_PageDetails || {}) : null;

    const companyName = isStorage
        ? ((sp.StorageAccount && sp.StorageAccount.CompanyName) || '')
        : (((cpDetails.ContactInformation || {}).CompanyName) || '');

    const contactPersonsRaw = isStorage
        ? (Array.isArray(sp.ContactPersons) ? sp.ContactPersons : [])
        : (Array.isArray((cpDetails.ContactInformation || {}).ContactPersons) ? (cpDetails.ContactInformation || {}).ContactPersons : []);

    // Non-storage job status (only compute when not storage)
    let hideUpdateBtn = false;
    if (!isStorage) {
        const estimateCompanyInfo = cpDetails.EstimateAndCompanyInfo || {};
        const estimateInfo = estimateCompanyInfo.Estimate || {};
        const isJobCancelled = !!estimateInfo.CancelJob;
        const estimateDetails = cpDetails.EstimateDetails || {};
        const rawJobDetails = estimateDetails.JobDetails || {};
        const nestedJobDetails = rawJobDetails.JobDetails || rawJobDetails;
        const isJobDeclined = !!(nestedJobDetails && (nestedJobDetails.DeclinedEvent || rawJobDetails.DeclinedEvent));
        hideUpdateBtn = isJobCancelled || isJobDeclined;
    }

    // Helpers (shared)
    const formatPhone = (val) => {
        if (!val) return '';
        const digits = String(val).replace(/\D/g,'');
        if (digits.length === 10) return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
        return val;
    };
    const normalizePhones = (p) => {
        if (!p) return [];
        if (Array.isArray(p)) return p.filter(x=>x && x!=='').map(formatPhone);
        return [formatPhone(p)];
    };

    // Normalize contact objects to a unified shape for rendering
    const contacts = contactPersonsRaw.map((c, idx) => {
        const fullName = c.FullName || `${c.FirstName || ''} ${c.LastName || ''}`.trim();
        return {
            id: c.Id || c.id || `contact-${idx}`,
            fullName: fullName || 'Unnamed Contact',
            email: c.Email || c.Mail || '',
            phones: normalizePhones(c.PhoneNumbers)
        };
    });

    const headingLabel = isStorage ? 'BILL TO:' : 'Contact Information';

    const handleModal = () => RecordsController.setContactInfoModal(false);
    const openModal = () => RecordsController.setContactInfoModal(true);

    // In storage mode we always allow update (unless business rules added later)
    const allowUpdate = isStorage ? true : !hideUpdateBtn;

    return (
        <div className="contact-information mb-4">
            <ul className="contact-info-list pl-0 mb-0">
                <li><h6 style={isStorage ? {color:'#000', fontWeight:700} : undefined}>{headingLabel}</h6></li>
                {companyName && <li><h4>{companyName}</h4></li>}
                {contacts.length === 0 && (
                    <li><span style={{fontSize:'12px', color:'#777'}}>No contacts available.</span></li>
                )}
                {contacts.map((c,key) => (
                    <li key={key+"li"}>
                        <h4 key={key+"h4"}>{c.fullName}</h4>
                        {c.phones.map((ph,i)=>(<span key={key+"span1"}>{ph}</span>))}
                        {c.email && <span key={key+"span2"}>{c.email}</span>}
                    </li>
                ))}
                {allowUpdate && (
                    <li>
                        <button id="updateButton" className="update-btn" onClick={openModal}>Update Contact Info</button>
                    </li>
                )}
                <Modal show={RecordsController.ContactInfoModal} onHide={handleModal} className='update-contact-info-wrap'>
                    <Modal.Header>
                        <h5 style={{color: "#37abdb", fontSize: "16px", fontWeight: 500}}>Update Contact Information</h5>
                        <button onClick={handleModal} style={{color: "red", background: "white", border: "white"}}>
                            <b className="contactInfoCloseBtn">X</b>
                        </button>
                    </Modal.Header>
                    <Modal.Body><ContactInfoForm mode={isStorage ? 'storage' : 'estimate'} /></Modal.Body>
                </Modal>

            </ul>
        </div>
    );
};